import { GetBlogPostsQuery } from '@/fo/api/magento';
import { RubricItem } from '@/fo/ui/article/section/top-five';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { urlMap } from '../consts';
import { BlogPageType } from '../types';

export const mapTopicArticles = (
  posts: GetBlogPostsQuery['mpBlogPosts'],
  type: BlogPageType
): RubricItem[] => {
  return (
    posts?.items
      ?.map((post) => {
        if (!post?.post_id || !post?.name || !post?.url_key) {
          return null;
        }

        return {
          id: post.post_id.toString(),
          title: post.name,
          imageUrl: post.small_image
            ? '/' + post.small_image
            : staticMediaUrl('blog/placeholder.png'),
          url: `/about-skin/${urlMap[type]}/${post.url_key}`
        };
      })
      .filter((item) => item !== null) ?? []
  );
};
